import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import './Dashboard.css';

const Dashboard = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  return (
    <div className="dashboard">
      <Navbar />
      
      <main className="dashboard-main">
        <div className="dashboard-sections">
          <div className="dashboard-section">
            <h2 className="section-title">{t('dashboard.sectionMatrices')}</h2>
            <div className="dashboard-cards">
              <Link to="/matrice" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('matrice.title')}</h3>
                    <p>{t('dashboard.matriceSubtitle')}</p>
                  </div>
                  <img src="/dashboard/A-matrice.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
              
              <Link to="/history" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('history.title')}</h3>
                    <p>{t('dashboard.historySubtitle')}</p>
                  </div>
                  <img src="/dashboard/B-history.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
              
              <Link to="/thecircle" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('dashboard.circleTitle')}</h3>
                    <p>{t('dashboard.circleSubtitle')}</p>
                  </div>
                  <img src="/dashboard/C-thecircle.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
            </div>
          </div>

          <div className="dashboard-section">
            <h2 className="section-title">{t('dashboard.sectionDocuments')}</h2>
            <div className="dashboard-cards">
              <Link to="/document" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('document.title')}</h3>
                    <p>{t('dashboard.documentSubtitle')}</p>
                  </div>
                  <img src="/dashboard/D-document.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
              
              <Link to="/document-history" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('documentHistory.title')}</h3>
                    <p>{t('dashboard.documentHistorySubtitle')}</p>
                  </div>
                  <img src="/dashboard/E-document-history.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
              
              <Link to="/animated-editor" className="dashboard-card">
                <div className="dashboard-card-content">
                  <div className="dashboard-card-text">
                    <h3>{t('dashboard.animatedDocumentTitle')}</h3>
                    <p>{t('dashboard.animatedDocumentSubtitle')}</p>
                  </div>
                  <img src="/dashboard/F-animated-editor.jpg" alt="" className="dashboard-card-icon" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;

